import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const fhirApi = baseApi.injectEndpoints({
  tagTypes: ["FhirPatients"],
  endpoints: (builder) => ({
    getFhirPatients: builder.query({
      query: (params) => {
        return {
          url: `/fhirPatients/index.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    updateFhirPatient: builder.mutation({
      query: (params) => {
        return {
          url: `/fhirPatients/update.json`,
          method: "POST",
          body: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetFhirPatientsQuery,
  useUpdateFhirPatientMutation,
} = fhirApi;
